import { __assign } from "tslib";
import { styled, MenuItem as MuiMenuItem } from '@mui/material';
var sizeMixIn = function (_a) {
    var _b, _c;
    var theme = _a.theme, size = _a.size;
    return (__assign(__assign({}, (size === 'small' && (_b = {},
        _b[theme.breakpoints.up('sm')] = {
            minHeight: theme.spacing(4),
            paddingTop: theme.spacing(0.625),
            paddingBottom: theme.spacing(0.625), //5,
        },
        _b))), (size === 'medium' && (_c = {},
        _c[theme.breakpoints.up('sm')] = {
            minHeight: theme.spacing(5), //40,
        },
        _c))));
};
export var StyledMenuItem = styled(MuiMenuItem, {
    shouldForwardProp: function (prop) { return !['size'].includes(String(prop)); },
})(function (_a) {
    var _b;
    var theme = _a.theme, size = _a.size;
    return (__assign(__assign((_b = {}, _b[theme.breakpoints.up('sm')] = {
        minHeight: theme.spacing(4),
        paddingTop: theme.spacing(0.625),
        paddingBottom: theme.spacing(0.625), //5,
    }, _b), (size && sizeMixIn({ theme: theme, size: size }))), { '&:has(input[type="checkbox"])': {
            paddingTop: theme.spacing(0.5),
            paddingBottom: theme.spacing(0.5),
            paddingLeft: theme.spacing(0.5),
            '.MuiCheckbox-root': {
                marginRight: theme.spacing(1), //8,
            },
        } }));
});
//# sourceMappingURL=styled.js.map